export const namespaced = true;

export const state = {
    materials: [],
    main_materials: [],
    material: {},
    types: [],
    type: null,
    meta: null,
    page: 1,
    per_page: 25,
    loading: false,

}

export const mutations = {
    FETCH_MATERIALS(state, materials) {
        state.materials = materials;
    },
    FETCH_MAIN_MATERIALS(state, materials) {
        state.main_materials = materials;
    },
    FETCH_TYPES(state, types) {
        state.types = types;
    },
    ADD_MATERIAL(state, material) {
        state.materials.unshift(material);
    },
    FETCH_MATERIAL(state, material) {
        state.material = material;
    },
    MATERIAL_TOGGLE_MAIN(state) { },
    MATERIAL_REMOVE(state) { },
    SET_PAGE(state, page) {
        state.page = page;
    },
    SET_PER_PAGE(state, per_page) {
        state.per_page = per_page;
    },
    SET_TYPE(state, type) {
        state.type = type;
    },
    FETCH_META(state, meta) {
        state.meta = meta;
    },
}

export const actions = {

    async fetch({ commit, state, dispatch }) {

        try {
            const res = (await axios.get(`/api/admin/materials`, {
                params: {
                    page: state.page,
                    type: state.type,
                    per_page: state.per_page
                }
            })).data;
            commit('FETCH_MATERIALS', res.data);
            commit('FETCH_META', res.meta);
            return res.data;
        } catch (error) {
            const material = {
                type: 'error',
                message: error.response && error.response.data && error.response.data.message
            }
            dispatch('material/add', material, { root: true })
        }
    },

    async getAll({ commit, state, dispatch }) {
        try {
            const res = (await axios.get(`/api/admin/all-materials`)).data;
            commit('FETCH_MATERIALS', res.data);
            commit('FETCH_META', res.meta);
            return res.data;
        } catch (error) {
            const material = {
                type: 'error',
                message: error.response && error.response.data && error.response.data.message
            }
            dispatch('material/add', material, { root: true })
        }
    },

    setPage({ commit, state, dispatch }, page) {
        commit('SET_PAGE', page);
        dispatch('fetch');
    },

    setPerPage({ commit, state, dispatch }, per_page) {
        commit('SET_PAGE', 1);
        commit('SET_PER_PAGE', per_page);
        dispatch('fetch');
    },

    setType({ commit, state, dispatch }, type) {
        commit('SET_PAGE', 1);
        commit('SET_TYPE', type);
        dispatch('fetch');
    },

    async fetchMainMaterials({ commit, state, dispatch }) {

        try {
            const res = (await axios.get(`/api/admin/main-materials`)).data;
            commit('FETCH_MAIN_MATERIALS', res.data);
            return res.data;
        } catch (error) {
            const notification = {
                type: 'error',
                message: error.response && error.response.data && error.response.data.message
            }
            dispatch('notification/add', notification, { root: true })
        }
    },

    async fetchMaterial({ commit, state, dispatch }, material_id) {

        try {
            const res = (await axios.get(`/api/admin/materials/${material_id}`)).data;
            commit('FETCH_MATERIAL', res.data);
            return res.data;
        } catch (error) {
            const notification = {
                type: 'error',
                message: error.response && error.response.data && error.response.data.message
            }
            dispatch('notification/add', notification, { root: true })
        }
    },

    async fetchTypes({ commit, state, dispatch }) {

        try {
            const res = (await axios.get(`/api/admin/materials/types`)).data;
            commit('FETCH_TYPES', res.data);
            return res.data;
        } catch (error) {
            const notification = {
                type: 'error',
                message: error.response && error.response.data && error.response.data.message
            }
            dispatch('notification/add', notification, { root: true })
        }
    },

    async toggleMain({ commit, dispatch }, material_id) {
        try {
            const res = (
                await axios.patch(
                    `/api/admin/materials/${material_id}/toggle-main`
                )
            ).data;
            commit('MATERIAL_TOGGLE_MAIN');

            dispatch('fetch');
            dispatch('fetchMainMaterials');

            const notification = {
                type: "success",
                message: "Запрос выполнен успешно",
            };
            dispatch("notification/add", notification, { root: true });
        } catch (error) {
            const notification = {
                type: 'error',
                message: error.response && error.response.data && error.response.data.message
            }
            dispatch('notification/add', notification, { root: true });
            throw error;
        }
    },

    async toggleStatus({ commit, dispatch }, material_id) {
        try {
            const res = (
                await axios.patch(
                    `/api/admin/materials/${material_id}/toggle-status`
                )
            ).data;

            dispatch('fetch');

            const notification = {
                type: "success",
                message: "Запрос выполнен успешно",
            };
            dispatch("notification/add", notification, { root: true });
        } catch (error) {
            const notification = {
                type: 'error',
                message: error.response && error.response.data && error.response.data.message
            }
            dispatch('notification/add', notification, { root: true });
            throw error;
        }
    },

    async remove({ commit, dispatch }, material_id) {
        try {
            const res = (
                await axios.delete(
                    `/api/admin/materials/${material_id}`
                )
            ).data;
            commit('MATERIAL_REMOVE');

            dispatch('fetch');

            const notification = {
                type: "success",
                message: "Материал успешно удален",
            };
            dispatch("notification/add", notification, { root: true });
        } catch (error) {
            const notification = {
                type: 'error',
                message: error.response && error.response.data && error.response.data.message
            }
            dispatch('notification/add', notification, { root: true });
            throw error;
        }
    },





}
